<template>
  <div class="permission-setting container-style">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm" class="form-inline">
        <el-form-item label="总分店:">
          <el-select v-model="searchForm.shopType" placeholder="请选择" @change="selectShopType">
            <el-option
              v-for="item in shopOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品:">
          <el-select v-model="searchForm.platformType" placeholder="请选择">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:">
          <el-select v-model="searchForm.roleId" placeholder="请选择">
            <el-option
              v-for="item in roleOptions"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营模式:" v-if="searchForm.platformType !== 1&&searchForm.shopType !== 1">
          <el-select v-model="searchForm.shopModel" placeholder="请选择">
            <el-option
              v-for="item in shopModelOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click="searchClick">查询</el-button> -->
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            @click.native="searchClick"
            label="查询"
            :loading="loadingTable"
          ></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        border
        style="width:100%;margin-bottom:20px"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :cell-style="cellStylePadding0"
      >
        <el-table-column prop="title"  label="功能模块" align="center">
        </el-table-column>
        <el-table-column  label="子模块" align="center" prop="sonModel">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.children"  :key="index">
              <ul class="sonModel">
                <li v-for="(item1,index1) in item.children"  :key="index1">
                  {{item1.title}}
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作权限"
          align="center"
          prop="operation"
        >
          <template slot-scope="scope">
           <div v-for="(item,index) in scope.row.children"  :key="index">
              <ul class="sonModel">
                <li v-for="(item1,index1) in item.children"  :key="index1">
                  <template v-if="item1.handler&&item1.handler.length>0">
                     <span v-for="(item2,index2) in item1.handler"  :key="index2">
                     {{item2.title}}
                  </span>
                  </template>
                  <span v-else>
                    无
                  </span>
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getAllRoleInfo, queryMenu } from '@/api/userAccount.js'
export default {
  data () {
    return {
      loadingTable: false,
      roleOptions: [],
      shopOptions: this.$enum.getMapItems('shopType'),
      platformOptions: this.$enum.getMapItems('platformType'),
      shopModelOptions: this.$enum.getMapItems('shopModel'),
      searchForm: {
        shopType: '',
        platformType: '',
        roleId: '',
        shopModel: ''
      }
    }
  },
  mounted () {
    // this.getAllRoleInfo()
    this.setDefaultData()
    this.getRoleInfo()
    this.getList()
  },
  methods: {
    cellStylePadding0 ({ row, column, ronIndex, columnIndex }) {
      if (
        column.property === 'sonModel' ||
        column.property === 'operation'
      ) {
        return 'padding:0'
      } else {
        return ''
      }
      // console.log(column.property)
    },
    setDefaultData () {
      this.searchForm.shopType = this.shopOptions[0].value
      this.searchForm.platformType = this.platformOptions[0].value
      this.searchForm.shopModel = ''
    },
    selectShopType (val) {
      this.getRoleInfo()
    },
    getRoleInfo () {
      if (+this.searchForm.shopType === 1) {
        this.roleOptions = [
          {
            roleId: 10002,
            roleName: '总店店长'
          },
          {
            roleId: 10003,
            roleName: '总店店员'
          }
        ]
      } else {
        this.roleOptions = [
          {
            roleId: 10004,
            roleName: '分店管理员'
          }
        ]
      }
      this.searchForm.roleId = this.roleOptions[0].roleId
    },
    getAllRoleInfo () {
      getAllRoleInfo().then(response => {
        if (+response.error_code === 0) {
          console.log('response: ', response)
          this.roleOptions = response.data
          this.searchForm.roleId = this.roleOptions[0].roleId
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    searchClick () {
      this.getList()
    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm)
      queryMenu(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          console.log('response: ', response)
          this.tableData = response.navBar
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sonModel{
  display: flex;
  flex-direction: column;
  margin: 0 -10px;
  li{
    flex: 1;
    line-height: 32px;
    border-bottom: 1px solid #EBEEF5;
    &:last-child{
      border-bottom: 0;
    }
    span{
      padding: 10px;
      margin-right: 5px;
    }
  }
}
</style>
